/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { ReactComponent as TrFlag } from "components/widgets/language/icon-lang-turkish.svg";
import { ReactComponent as EnFlag } from "components/widgets/language/icon-lang-english.svg";
const ActiveLanguage = () => {
  const getLanguage = () => {
    switch (localStorage.getItem("i18nextLng")) {
      case "tr-TR":
        return ["Türkçe", <TrFlag className="img-fluid flag" />];
      case "en-US":
        return ["English", <EnFlag className="img-fluid flag" />];
      default:
        return ["Türkçe", <TrFlag className="img-fluid flag" />];
    }
  };

  return (
    <div className="activeLang">
      {getLanguage()[1]}
      {getLanguage()[0]}
    </div>
  );
};

export default ActiveLanguage;
